import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { AuthProvider } from "./AuthContext";
import { Header } from "./components/Header";
import { ProtectedRoute } from "./components/ProtectedRoute";
import BoardPage from "./pages/BoardPage";
import NewRequestPage from "./pages/NewRequestPage";
import RequestDetailPage from "./pages/RequestDetailPage";
import ProductsBoardPage from "./pages/ProductsBoardPage";
import NewProductPage from "./pages/NewProductPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import SellerProfilePage from "./pages/SellerProfilePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/AuthPages";
import MyListingsPage from "./pages/MyListingsPage";
import AdminPanelPage from "./pages/AdminPanelPage";
import SavedPage from "./pages/SavedPage";
import MatchesPage from "./pages/MatchesPage";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-background">
            <Header />
            <main data-testid="main-content">
              <Routes>
                <Route path="/" element={<BoardPage />} />
                <Route path="/new" element={<ProtectedRoute><NewRequestPage /></ProtectedRoute>} />
                <Route path="/r/:id" element={<RequestDetailPage />} />
                <Route path="/products" element={<ProductsBoardPage />} />
                <Route path="/new-product" element={<ProtectedRoute><NewProductPage /></ProtectedRoute>} />
                <Route path="/p/:id" element={<ProductDetailPage />} />
                <Route path="/s/:name" element={<SellerProfilePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/my-listings" element={<ProtectedRoute><MyListingsPage /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><AdminPanelPage /></ProtectedRoute>} />
                <Route path="/saved" element={<ProtectedRoute><SavedPage /></ProtectedRoute>} />
                <Route path="/matches" element={<ProtectedRoute><MatchesPage /></ProtectedRoute>} />
              </Routes>
            </main>
            <footer className="border-t border-border mt-24 py-10 px-6 md:px-10">
              <div className="mx-auto max-w-[1400px] flex flex-col sm:flex-row justify-between items-center gap-3">
                <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-muted-foreground">
                  Wholesale & Retail · buy request & product board
                </div>
                <div className="text-xs text-muted-foreground font-mono-brand">
                  Public marketplace · Free to browse
                </div>
              </div>
            </footer>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: { fontFamily: "Inter, sans-serif" },
                className: "border border-border",
              }}
            />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
